<button mat-icon-button
  (click)="onSpeech(); $event.stopPropagation()"
  matTooltip="{{'COMMON.HELP' | translate}}"
  type="button">
  <mat-icon>help</mat-icon>
</button>